import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { DollarSign, Eye } from 'lucide-react';

const statusVariant = {
  unpaid: 'outline',
  paid: 'default',
  void: 'secondary'
};

export default function TrackTable({
  rows,
  onMarkPaid,
  onViewTrack,
  marking,
}) {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Agent</TableHead>
            <TableHead>Consultant</TableHead>
            <TableHead className="text-right">Hours</TableHead>
            <TableHead className="text-right">Rate</TableHead>
            <TableHead className="text-right">Amount</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="text-center text-muted-foreground py-6">
                No commission data for the selected filters.
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row) => (
              <TableRow key={`${row.trackId}-${row.consultantId || row.trackId}`}>
                <TableCell className="font-medium">{row.agentName}</TableCell>
                <TableCell>{row.consultantName}</TableCell>
                <TableCell className="text-right">{row.hours.toFixed(2)}</TableCell>
                <TableCell className="text-right">${row.rate.toFixed(2)}</TableCell>
                <TableCell className="text-right">${row.amount.toFixed(2)}</TableCell>
                <TableCell>
                  <Badge variant={statusVariant[row.status] || 'outline'} className="capitalize">
                    {row.status}
                  </Badge>
                </TableCell>
                <TableCell className="text-right space-x-2">
                  <Button variant="ghost" size="icon" onClick={() => onViewTrack(row.trackId)} aria-label="View track">
                    <Eye className="h-4 w-4" />
                  </Button>
                  {row.status === 'unpaid' && (
                    <Button
                      size="sm"
                      onClick={() => onMarkPaid(row.trackId)}
                      disabled={marking === row.trackId}
                    >
                      <DollarSign className="h-4 w-4 mr-1" />
                      {marking === row.trackId ? 'Marking…' : 'Mark Paid'}
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
